module.exports = __webpack_public_path__ + "288ab91d54f725f80832beb90ccc996e.svg";